export const type = {
  PDF: ".pdf",
  IMAGE: "image/jpeg,image/jpg,image/JPEG,image/JPG, image/png, image/gif",
  CSV: ".csv",
};
